import ClubManagementPage from './ClubManagementPage'

export default ClubManagementPage
